import React from 'react';
import Acompanian from '../componentes/acompanian';
import Organizan from '../componentes/organizan';

import img from '../img/acercade.png';

export default function AcercaDe() { 

  document.title = "Hackaton 3d :: A cerca de";
    
  return (
      <React.Fragment>
        <h2 className="text-center mb-5 mt-5">ACERCA DE</h2>

        <img src={img} alt="foto" className="img-fluid" />
        <p className="mt-3">El Hackaton 3D organizado por el Colegio Universitario IES y su Carrera de Diseño e Impresión 3D, tiene el objetivo de desarrollar objetos 3D para ayudar a personas no videntes, que se apliquen fundamentalmente en el ámbito educativo (a definir con las fundaciones según necesidades a cubrir).</p>
<p>Objetivos específicos Hackaton 2019:</p>
        <ul className="mb-5 list-text">
            <li>Obtener modelos de piezas a imprimir en 3D para no videntes</li>
            <li>Conseguir modificar una impresora 3D para que pueda generar papeles con braille.</li>
            <li>Conocer casos de éxito de aplicación 3D en estas necesidades.</li>
            <li>Contribuir al desarrollo de la sociedad con Innovación (La base de nuestra misión).</li>
            <li>Difundir las utilidades y aplicaciones de la impresión 3D.</li>
            <li>Publicar los diseños creados en la Hackaton para su libre uso.</li>
          </ul>

        <Acompanian />
        <Organizan />
      </React.Fragment>    
  );
}